module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/kv@3x-7ed6b237e4185a78942820439a4d931b.png";